import React from 'react';
import { Container } from '../Container';
import { Section } from '../Section';
import { Reveal } from '../Reveal';
import { paymentStages } from '../../data/pricingDetails';
export function PaymentTerms() {
  return <Section tone="surface" bordered labelledBy="payment-title" data-id="element-727" data-mp="10k1echtm2ujr">
      <Container data-id="element-728" data-mp="wjqwo7wgifp2">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-10" data-id="element-729" data-mp="wj7ohiwlz5o8">
          <div className="lg:col-span-4" data-id="element-730" data-mp="whmr7liwt8mo">
            <Reveal data-id="element-731" data-mp="8uy9aztwhg62">
              <h2 id="payment-title" className="max-w-[12ch] text-[40px] leading-[1.05] tracking-[-0.03em] text-ink lg:text-[56px]" data-id="element-732" data-mp="8uenh814q7mr">
                Payment terms.
              </h2>
              <p className="mt-6 max-w-[38ch] text-body text-muted" data-id="element-733" data-mp="ho1l73owdkyl">
                Two payments, no retainer required, no invoices in between. Invoices are due within
                seven days and we accept bank transfer or card.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:col-start-6" data-id="element-734" data-mp="3h7lyrtw1lfor">
            <ol className="border-t border-hairline" data-id="element-735" data-mp="29o19lw69b51g">
              {paymentStages.map((stage, index) => <Reveal as="li" key={stage.title} delay={index * 0.06} data-id="element-736" data-mp="2emulxl9t4q01" data-mpi={index}>
                  <div className="grid gap-4 border-b border-hairline py-9 md:grid-cols-12 md:gap-8" data-id="element-737" data-mp="2jecfho9i3oaz">
                    <p className="font-serif text-[44px] leading-none tracking-[-0.04em] text-ink md:col-span-3" data-id="element-738" data-mp="2oe8gdemwizmb">
                      {stage.share}
                    </p>
                    <div className="md:col-span-9" data-id="element-739" data-mp="1vpb7u38hsh6r">
                      <h3 className="text-[20px] leading-[1.3] tracking-[-0.02em] text-ink" data-id="element-740" data-mp="1vptfdw0luhtz">
                        {stage.title}
                      </h3>
                      <p className="mt-3 max-w-[46ch] text-body text-muted" data-id="element-741" data-mp="25o0hx9u5cxcg">{stage.description}</p>
                    </div>
                  </div>
                </Reveal>)}
            </ol>
          </div>
        </div>
      </Container>
    </Section>;
}